<update-profile (close)="close($event)" (update)="updateProfile($event)" [user]="data?.user"></update-profile>